/*
 * This file holds the css used to pass through into the fluidpay hosted form to style the forms.
 * Styles passed to FluidPay through the settings.styles parameter to format the fields inside its hosted iframe.
 *
 * The fluidpay-tokenizer.component.css file styles our outer Angular component and
 * container, but its CSS cannot reach the fields inside FluidPay's iframe.
 *
 * These styles are exported as a TypeScript object because FluidPay expects
 * an object for this parameter. This export cannot go in a .css file because
 * it uses TypeScript syntax.
 */

export const FluidpayFieldStyles: Record<string, Record<string, string>> = {
    'body': {
        'margin': '0',
        'padding': '0',
        'background-color': 'transparent',
        'font-family': 'Arial, sans-serif',
        'font-size': '16px',
        'color': '#000 !important'
    },

    // Remove the SDK's horizontal grouping.
    '.fieldsetrow, .fieldsetgroup': {
        'display': 'block !important',
        'width': '100% !important',
        'max-width': 'none !important',
        'min-width': '0',
        'margin': '0 !important',
        'padding': '0 !important',
        'box-sizing': 'border-box'
    },

    '.break': {
        'display': 'none'
    },

    // Give every row the same label and input columns.
    '.fieldset.type, .fieldset.account, .fieldset.routing': {
        'display': 'grid !important',
        'grid-template-columns': '245px minmax(0, 300px)',
        'align-items': 'center',
        'gap': '0',
        'float': 'none !important',
        'width': '100% !important',
        'max-width': 'none !important',
        'min-width': '0',
        'margin': '0 0 10px 0 !important',
        'padding': '0 !important',
        'box-sizing': 'border-box'
    },

    // Visible labels outside the controls.
    '.fieldset.type::before': {
        'content': '"Account Type:"'
    },

    '.fieldset.account::before': {
        'content': '"Account Number:"'
    },

    '.fieldset.routing::before': {
        'content': '"Routing Number:"'
    },

    '.fieldset.type::before, .fieldset.account::before, .fieldset.routing::before': {
        'display': 'block',
        'width': 'auto',
        'margin': '0',
        'padding-right': '8px',
        'box-sizing': 'border-box',
        'font-family': 'Arial, sans-serif',
        'font-size': '16px',
        'font-weight': '400',
        'color': '#222',
        'opacity': '1'
    },

    // Make the dropdown and both inputs fill the input column.
    '.fieldset.type select, .fieldset.account input, .fieldset.routing input': {
        'display': 'block !important',
        'position': 'static !important',
        'width': '100% !important',
        'max-width': 'none !important',
        'min-width': '0 !important',
        'height': '25px',
        'margin': '0 !important',
        'padding': '2px 4px',
        'box-sizing': 'border-box',
        'border': '1px solid #888',
        'border-radius': '0',
        'background-color': '#fff',
        'color': '#222',
        'font-family': 'Arial, sans-serif',
        'font-size': '14px',
        'box-shadow': 'none'
    },

    // Keep the native dropdown arrow and selected option visible.
    '.fieldset.type select': {
        'appearance': 'auto',
        '-webkit-appearance': 'auto'
    },

    // Hide duplicate text inside the empty inputs.
    '.fieldset.account input::placeholder, .fieldset.routing input::placeholder': {
        'color': 'transparent',
        'opacity': '0'
    },
}